const snackConst = {};
const CURRENCY = "Lei";
const otpRegex = /^\d{6}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
// const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;

const skuRegex = /^[A-Za-z0-9_-]{3,30}$/;
const partialSkuRegex = /^[A-Za-z0-9_-]*$/;

const DEFAULT_VAT_PERCENTAGE = 21;

const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
  PATCH: "patch",
};

const CSK_CONFIG = {
  heading: {
    options: [
      {
        model: "paragraph",
        title: "Paragraph",
        class: "ck-heading_paragraph",
      },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
      {
        model: "heading3",
        view: "h3",
        title: "Heading 3",
        class: "ck-heading_heading3",
      },
      {
        model: "heading4",
        view: "h4",
        title: "Heading 4",
        class: "ck-heading_heading4",
      },
      {
        model: "heading5",
        view: "h5",
        title: "Heading 5",
        class: "ck-heading_heading5",
      },
      {
        model: "heading6",
        view: "h6",
        title: "Heading 6",
        class: "ck-heading_heading6",
      },
    ],
  },
};

const COLOR_OPTIONS = [
  { value: "#FFFFFF", label: "White" },
  { value: "#000000", label: "Black" },
  { value: "#F44336", label: "Red" },
  { value: "#E91E63", label: "Pink" },
  { value: "#9C27B0", label: "Purple" },
  { value: "#673AB7", label: "Deep Purple" },
  { value: "#3F51B5", label: "Indigo" },
  { value: "#2196F3", label: "Blue" },
  { value: "#03A9F4", label: "Light Blue" },
  { value: "#00BCD4", label: "Cyan" },
  { value: "#009688", label: "Teal" },
  { value: "#4CAF50", label: "Green" },
  { value: "#8BC34A", label: "Light Green" },
  { value: "#CDDC39", label: "Lime" },
  { value: "#FFEB3B", label: "Yellow" },
  { value: "#FFC107", label: "Amber" },
  { value: "#FF9800", label: "Orange" },
  { value: "#FF5722", label: "Deep Orange" },
  { value: "#795548", label: "Brown" },
  { value: "#9E9E9E", label: "Gray" },
  { value: "#607D8B", label: "Blue Gray" },

  // Additional commonly used colors
  { value: "#F8BBD0", label: "Light Pink" },
  { value: "#E1BEE7", label: "Lavender Pink" },
  { value: "#D1C4E9", label: "Lavender" },
  { value: "#C5CAE9", label: "Periwinkle" },
  { value: "#BBDEFB", label: "Baby Blue" },
  { value: "#B3E5FC", label: "Sky Blue" },
  { value: "#B2EBF2", label: "Aqua" },
  { value: "#B2DFDB", label: "Mint" },
  { value: "#C8E6C9", label: "Light Green" },
  { value: "#DCEDC8", label: "Lime Light" },
  { value: "#FFF9C4", label: "Light Yellow" },
  { value: "#FFECB3", label: "Peach" },
  { value: "#FFE0B2", label: "Apricot" },
  { value: "#FFCCBC", label: "Salmon" },
  { value: "#D7CCC8", label: "Beige" },
  { value: "#CFD8DC", label: "Light Gray" },
  { value: "#F5F5F5", label: "Off White" },
  { value: "#FAFAFA", label: "Snow" },
  { value: "#E0F7FA", label: "Light Cyan" },
  { value: "#F1F8E9", label: "Honeydew" },
  { value: "#FFF3E0", label: "Cream" },
  { value: "#F3E5F5", label: "Mauve" },
  { value: "#FFCDD2", label: "Coral" },
  { value: "#B0BEC5", label: "Steel Gray" },
  { value: "#8D6E63", label: "Taupe" },
  { value: "#A1887F", label: "Light Brown" },
  { value: "#D32F2F", label: "Crimson" },
  { value: "#C2185B", label: "Magenta" },
  { value: "#7B1FA2", label: "Violet" },
  { value: "#303F9F", label: "Royal Blue" },
  { value: "#0288D1", label: "Dodger Blue" },
  { value: "#00796B", label: "Teal Dark" },
  { value: "#388E3C", label: "Emerald" },
  { value: "#FBC02D", label: "Golden Yellow" },
  { value: "#F57C00", label: "Pumpkin" },
  { value: "#E64A19", label: "Burnt Orange" },
];

const SIZES_OPTIONS = [
  { value: "XXS", label: "XXS" },
  { value: "XS", label: "XS" },

  // Standard adult sizes
  { value: "S", label: "S" },
  { value: "M", label: "M" },
  { value: "L", label: "L" },
  { value: "XL", label: "XL" },
  { value: "XXL", label: "XXL" },

  // Plus sizes
  { value: "XXXL", label: "XXXL" },
  { value: "XXXXL", label: "XXXXL" },
  { value: "XXXXXL", label: "XXXXXL" },
];

const SIZE_TYPES = [
  {
    label: "INT",
    value: "INT",
  },
  {
    label: "EU",
    value: "EU",
  },
  {
    label: "UK",
    value: "UK",
  },
  {
    label: "US",
    value: "US",
  },
  {
    label: "CM",
    value: "CM",
  },
];

const SIZE_BY_TYPE = {
  // ======================
  // 🌍 INTERNATIONAL (CLOTHING)
  // ======================
  INT: [
    { label: "XXXS", value: "xxxs" },
    { label: "XXS", value: "xxs" },
    { label: "XS", value: "xs" },
    { label: "S", value: "s" },
    { label: "M", value: "m" },
    { label: "L", value: "l" },
    { label: "XL", value: "xl" },
    { label: "XXL", value: "xxl" },
    { label: "XXXL", value: "xxxl" },
  ],

  // ======================
  // 🇪🇺 EU (ROMANIA PRIMARY)
  // ======================
  EU: [
    { label: "32", value: "32" },
    { label: "34", value: "34" },
    { label: "36", value: "36" },
    { label: "38", value: "38" },
    { label: "40", value: "40" },
    { label: "42", value: "42" },
    { label: "44", value: "44" },
    { label: "46", value: "46" },
    { label: "48", value: "48" },
    { label: "50", value: "50" },
    { label: "52", value: "52" },
    { label: "54", value: "54" },
  ],

  // ======================
  // 🇬🇧 UK (CLOTHING)
  // ======================
  UK: [
    { label: "4", value: "4" },
    { label: "6", value: "6" },
    { label: "8", value: "8" },
    { label: "10", value: "10" },
    { label: "12", value: "12" },
    { label: "14", value: "14" },
    { label: "16", value: "16" },
    { label: "18", value: "18" },
    { label: "20", value: "20" },
  ],

  // ======================
  // 🇺🇸 US (CLOTHING)
  // ======================
  US: [
    { label: "0", value: "0" },
    { label: "2", value: "2" },
    { label: "4", value: "4" },
    { label: "6", value: "6" },
    { label: "8", value: "8" },
    { label: "10", value: "10" },
    { label: "12", value: "12" },
    { label: "14", value: "14" },
    { label: "16", value: "16" },
  ],

  // ======================
  // 📏 CM (FOOTWEAR / KIDS / EXACT)
  // ======================
  CM: [
    { label: "22 cm", value: "22" },
    { label: "23 cm", value: "23" },
    { label: "24 cm", value: "24" },
    { label: "25 cm", value: "25" },
    { label: "26 cm", value: "26" },
    { label: "27 cm", value: "27" },
    { label: "28 cm", value: "28" },
    { label: "29 cm", value: "29" },
    { label: "30 cm", value: "30" },
  ],
};

const WEIGHT_OPTIONS = [
  { value: "500g", label: "500g" },
  { value: "1kg", label: "1kg" },
  { value: "2kg", label: "2kg" },
  { value: "3kg", label: "3kg" },
  { value: "4kg", label: "4kg" },
  { value: "5kg", label: "5kg" },
];

const PREDEFINED_ATTRIBUTES = [
  { label: "Color", value: "color" },
  { label: "Size", value: "size" },
  { label: "Weight", value: "weight" },
];

const ECOMMERCE_SOLUTION_TYPE = [
  {
    value: "business",
    label: {
      en: "Business",
      ro: "Afaceri",
    },
  },
  {
    value: "home",
    label: {
      en: "Home",
      ro: "Casă",
    },
  },
];

const PRODUCT_USAGE_TYPE = [
  {
    value: "home",
    label: {
      en: "Normal",
      ro: "Normal",
    },
  },
  {
    value: "business",
    label: {
      en: "Professional",
      ro: "Profesionist",
    },
  },
];

const PACKAGE_USAGE_TYPE = [
  {
    value: "home",
    label: {
      en: "Home",
      ro: "Obișnuit",
    },
  },
  {
    value: "business",
    label: {
      en: "Business",
      ro: "Afaceri",
    },
  },
];

const BANNER_POSITION = [
  {
    label: {
      en: "Store Banner",
      ro: "Banner de magazin",
    },
    value: "store_banner",
  },
  {
    label: {
      en: "Cleaning Banner",
      ro: "Banner de curățenie",
    },
    value: "cleaning_banner",
  },
  {
    label: {
      en: "Business Solution Banner",
      ro: "Banner de soluție de afaceri",
    },
    value: "business_solution_banner",
  },
  {
    label: {
      en: "Home Solution Banner",
      ro: "Banner de soluție de casă",
    },
    value: "home_solution_banner",
  },
  {
    label: {
      en: "Category Banner",
      ro: "Banner de categorie",
    },
    value: "category_banner",
  },
  {
    label: {
      en: "Products",
      ro: "Produse",
    },
    value: "products_banner",
  },
  {
    label: {
      en: "Plan Banner",
      ro: "Banner de plan",
    },
    value: "plan_banner",
  },
  {
    label: {
      en: "Charity Banner",
      ro: "Banner pentru acțiune caritabilă",
    },
    value: "charity_banner",
  },
  {
    label: {
      en: "Family Care Banner",
      ro: "Banner „Îngrijirea familiei”",
    },
    value: "family_care_banner",
  },
  {
    label: {
      en: "Gift Card Banner",
      ro: "Banner pentru carduri cadou",
    },
    value: "gift-card-banner",
  },
  {
    label: {
      en: "Pregnancy Hub Banner",
      ro: "Banner Hub pentru Sarcină",
    },
    value: "pregnancy_hub_banner",
  },
  {
    label: {
      en: "Event Banner",
      ro: "Banner pentru evenimente",
    },
    value: "event_banner",
  },
  {
    label: {
      en: "Join Us Banner",
      ro: "Banner pentru a ne alătura",
    },
    value: "join_us_banner",
  },
];

const TAG_APPLIES_TO = [
  {
    value: "product",
    label: {
      en: "Product",
      ro: "Produs",
    },
  },
  {
    value: "package",
    label: {
      en: "Package",
      ro: "Pachete",
    },
  },
];

const ALL_BLOG_CATEGORY = [
  {
    title: {
      en: "Ecommerce",
      ro: "Comerț electronic",
    },
    type: "ecommerce",
  },
  {
    title: {
      en: "Cleaning Service",
      ro: "Serviciu de curatenie",
    },
    type: "cleaning",
  },
  {
    title: {
      en: "Car Service",
      ro: "Service auto",
    },
    type: "car",
  },
];

const PLAN_DELIVERY_TYPES = [
  {
    label: {
      en: "Weekly",
      ro: "Săptămânal",
    },
    value: "weekly",
  },
  {
    label: {
      en: "Biweekly",
      ro: "Bifăptămânal",
    },
    value: "biweekly",
  },
  {
    label: {
      en: "Monthly",
      ro: "Luniar",
    },
    value: "monthly",
  },
  {
    label: {
      en: "Quarterly",
      ro: "Trimestrial",
    },
    value: "quarterly",
  },
];

const INVENTORY_MOVEMENT_REASON = [
  {
    value: "stock_in",
    label: {
      en: "Stock In",
      ro: "Intrare în stoc",
    },
  },
  {
    value: "stock_out",
    label: {
      en: "Stock Out",
      ro: "Ieșire din stoc",
    },
  },
  {
    value: "release",
    label: {
      en: "Release",
      ro: "Eliberare",
    },
  },
  {
    value: "adjustment",
    label: {
      en: "Adjustment",
      ro: "Ajustare",
    },
  },
  {
    value: "price_adjustment",
    label: {
      en: "Price Adjustment",
      ro: "Ajustare de preț",
    },
  },
];

const PROMOTIONAL_IMAGE_PAGE = [
  {
    label: {
      en: "Store",
      ro: "Magazin",
    },
    value: "store",
  },
  {
    label: {
      en: "Dashboard",
      ro: "Dashboard",
    },
    value: "dashboard",
  },
  {
    label: {
      en: "Add Item Plan Dialog",
      ro: "Dialog de adaugare a itemului plan",
    },
    value: "add_item_plan_dialog",
  },
  {
    label: {
      en: "Family Care",
      ro: "Îngrijirea familiei",
    },
    value: "family_care",
  },
  {
    label: {
      en: "Gift Card",
      ro: "Card cadou",
    },
    value: "gift_card",
  },
  {
    label: {
      en: "Pregnancy Hub",
      ro: "Centrul Sarcinii",
    },
    value: "pregnancy_hub",
  },
  {
    label: {
      en: "Event",
      ro: "Eveniment",
    },
    value: "event",
  },
  {
    label: {
      en: "Plan Guide",
      ro: "Ghid pentru Planuri",
    },
    value: "plan_guide",
  },
];

const PROMOTIONAL_IMAGE_SECTION = [
  {
    page: "store",
    label: {
      en: "After Home Package",
      ro: "După pachetul de casă",
    },
    value: "after_home_package",
  },
  {
    page: "store",
    label: {
      en: "Before Browse Product",
      ro: "Înainte de produse",
    },
    value: "before_browse_product",
  },
  {
    page: "dashboard",
    label: {
      en: "Top Of Dashboard",
      ro: "Susul dashboard-ului",
    },
    value: "top_of_dashboard",
  },
  {
    page: "add_item_plan_dialog",
    label: {
      en: "Header of The Dialog",
      ro: "Headerul dialogului",
    },
    value: "header_of_the_dialog",
  },
  {
    page: "add_item_plan_dialog",
    label: {
      en: "Left Side Of The Dialog",
      ro: "Stânga dialogului",
    },
    value: "left_side_of_the_dialog",
  },
  {
    page: "family_care",
    label: {
      en: "After third section",
      ro: "După a treia secțiune",
    },
    value: "after_third_section",
  },
  {
    page: "gift_card",
    label: {
      en: "Mid Section",
      ro: "Mid Section",
    },
    value: "mid_section",
  },
  {
    page: "pregnancy_hub",
    label: {
      en: "Mid Section",
      ro: "Mid Section",
    },
    value: "mid_section",
  },
  {
    page: "plan_guide",
    label: {
      en: "Mid Section",
      ro: "Mid Section",
    },
    value: "mid_section",
  },
  {
    page: "event",
    label: {
      en: "Bottom of the Page",
      ro: "Fundul paginii",
    },
    value: "bottom_of_the_page",
  },
];

const ORDER_STATUS_TRANSITIONS = {
  pending: ["processing", "cancelled", "user_cancelled"],
  processing: ["shipped", "cancelled", "user_cancelled"],
  shipped: ["delivered"],
  delivered: [],
  cancelled: [],
  user_cancelled: [],
};

const USER_LIFE_STAGES = [
  {
    title: {
      en: "Expecting Parent",
      ro: "Viitor Părinte",
    },
    value: "expecting_parent",
  },
  {
    title: {
      en: "Family Essentials",
      ro: "Produse Esențiale pentru Familie",
    },
    value: "family_essentials",
  },
  {
    title: {
      en: "New Home",
      ro: "Casă Nouă",
    },
    value: "new_home",
  },
];

const endPoints = {
  // Common Endpoints

  updateAllAcountStatus: "update/account-status",

  // Chat Endpoints
  getAllConversation: "chat/conversation/get-all",
  getAllChatsByConversatioId: "chat/messages",

  // Admin Authentcation Endpoints

  createAdmin: "admin/create",
  loginAdmin: "admin/login",
  changePasswordAdmin: "admin/change-password",
  updateProfileAdmin: "admin/update",

  // Dashboard Endpoints

  getAdminDashboardData: "admin/dashboard/get",

  // Report Endpoints

  getAdminReportData: "admin/report/get",

  // Ecommerce Category Endpoints

  createEcomCategory: "admin/ecom-category/create",
  getAllEcomCategory: "admin/ecom-category/get-all",
  updateEcomCategory: "admin/ecom-category/update",
  updateEcomCategoryStatus: "admin/ecom-category/status",
  deleteEcomCategory: "admin/ecom-category/delete",

  // Ecommerce Sub Category Endpoints

  createEcomSubCategory: "admin/ecom-sub-category/create",
  getAllEcomSubCategory: "admin/ecom-sub-category/get-all",
  updateEcomSubCategory: "admin/ecom-sub-category/update",
  updateEcomSubCategoryStatus: "admin/ecom-sub-category/status",
  deleteEcomSubCategory: "admin/ecom-sub-category/delete",

  // Ecommerce Sub Sub Category Endpoints
  subSubCategory: "admin/ecom-sub-sub-category",

  // Service Category Endpoints

  createServiceCategory: "admin/service-category/create",
  getAllServiceCategory: "admin/service-category/get-all",
  getServiceCategoryDetail: "admin/service-category/detail",
  updateServiceCategory: "admin/service-category/update",
  deleteServiceCategory: "admin/service-category/delete",

  // Service Sub Category Endpoints

  createServiceSubCategory: "admin/service-sub-category/create",
  getAllServiceSubCategory: "admin/service-sub-category/get-all",
  getAllServiceSubCategoryById: "admin/service-sub-category/get-by-id",
  updateServiceSubCategory: "admin/service-sub-category/update",
  deleteServiceSubCategory: "admin/service-sub-category/delete",

  // Suppliers Endpoints

  getAllSupplier: "supplier/get-all",

  // Companies Endpoints

  getAllCompanies: "company/get-all",
  getCompanyDetails: "company/get-details",
  deleteCompany: "company/delete",
  getAllCompanyForFilters: "company/get-for-filters",
  getCompanyBySubServices: "company/get-by-subservice",
  getCompanyServiceDetail: "company/service/get-detail",
  updateCompanyStatus: "company/update-status",

  // Web Users Endpoints

  getAllUsers: "user/get-all",
  updateUser: "user/update",
  blockUserStatus: "user/block-status",
  userWithdrawRequest: "user/withdraw-request",

  // Product Endpoints

  // Base Package endpoints

  createBasePackage: "supplier/base/package",
  getAllBasePackages: "supplier/base/packages",
  getBasePackageById: "supplier/base/package/id/:id",
  getBasePackageBySlug: "supplier/base/package/slug/:slug",
  exportBasePackages: "supplier/base/packages/export",
  updateBasePackage: "supplier/base/package/:id",
  deleteBasePackage: "supplier/base/package/:id",
  generateBasePackageSpecification: "base/package/specification/",

  // Orders Endpoints

  allOrders: "supplier/orders",
  exportAllOrders: "supplier/orders/export",
  getOrderDetailById: "supplier/order/:id",
  getAllSupplierOrders: "suppliers/:supplierId/orders",
  exportSupplierOrders: "supplier/:supplierId/orders/export",
  getSupplierOrderDetail: "supplier/:supplierId/order/:id",
  updateSupplierOrderItemStatus: "supplier/order/:id/item/:itemId/status",
  updateSupplierOrderStatusesInBulk: "supplier/order/:id/bulk-status",

  supplierOrderCreate: "supplier/order/create",
  supplierGetAllCLients: "supplier/client/get-all",
  supplierGetOrderDetail: "supplier/order/detail",
  supplierUpdateOrderStatus: "supplier/order/update-status",
  supplierHandleProductRefund: "supplier/order/refund-product",
  supplierReplaceProduct: "supplier/order/replace-product",
  supplierOrderCancelAndRefund: "supplier/order/cancel-and-refund",

  // Subscription Endpoints

  getAllSubscriptions: "admin/subscription/get-all",
  getAllSubscriptionsByRole: "admin/subscription/get-by-role",
  updateSubscription: "admin/subscription/update",

  // Subscription History Endpoints

  getSubscriptionHistoryByRole: "subscription-history/get-by-role",

  // Admin Role Endpoints

  createAdminRole: "admin/role/create",
  getAllAdminRole: "admin/role/get-all",
  getAdminRoleDetail: "admin/role/detail",
  updateAdminRole: "admin/role/update",
  deleteAdminRole: "admin/role/delete",

  // Admin user endpoints

  createAdminUser: "admin/user/create",
  getAllAdminUsers: "admin/user/get-all",
  deleteAdminUser: "admin/user/delete",
  updateAdminUser: "admin/user/update",

  // Admin Faq

  createAdminFaq: "admin/faq/create",
  gatAdminFaqByUserType: "admin/all-faq",
  updateAdminFaq: "admin/faq/update",
  deleteAdminFaq: "admin/faq/delete",

  // Notification endpoints

  createNotification: "admin/notification/create",
  getAllNotification: "admin/notification/get-all",
  getUserNotification: "admin/notification/get-by-role",
  markReadNotification: "notification/mark-all-read",

  // Worker Endpoints

  getAllWorkers: "worker/get-all",
  deleteWorker: "worker/delete",
  getAllWorkerForFilters: "worker/get-for-filters",
  getWorkerBySubservices: "worker/get-by-subServices",

  // Admin Setting Endpoints

  createSetting: "admin/setting/create",
  getSetting: "admin/setting/get-latest",
  updateSetting: "admin/setting/update",

  // Appointment Endpoints

  getAllAppointments: "admin/appointment/get-all",
  getAppointmentDetail: "company/appointment/detail",
  assignedAppoitment: "company/appointment/assigned",

  // Blogs

  suggestBlog: "blog/suggest",
  createBlog: "blog/create",
  getAllBlogs: "blog/get",
  getBlogDetail: "blog/get",
  updateBlog: "blog/update",
  deleteBlog: "blog/delete",

  // Custom packages
  getAllCustomPackages: "admin/custom/package",
  getCustomPackageDetail: "admin/custom/package/detail/:id",
  customPackageUpdate: "admin/custom/package/update/:url",
  deleteCustomPackage: "admin/custom/package/:id",
  exportCustomPackages: "admin/custom/packages/export",

  // Ecommerce Tags
  ecommerceTags: "admin/ecom-tag",
  getEcommerceTagById: "admin/ecom-tag/id",
  getEcommerceTagBySlug: "admin/ecom-tag/slug",

  // Banners
  banner: "admin/banner",
};

const ENDPOINTS = {
  PRODUCT: {
    CREATE: "supplier/product",
    UPDATE: "supplier/product/:id",
    UPDATE_STATUS: "supplier/product/:id/status",
    UPDATE_FEATURED_STATUS: "supplier/product/:id/featured-status",
    UPDATE_MEGA_DISCOUNT_STATUS: "supplier/product/:id/mega-discount-status",
    SINGLE_PRODUCT_BY_ID: "supplier/product/id/:id",
    SINGLE_PRODUCT_BY_SLUG: "supplier/product/slug/:slug",
    GET_ALL_PRODUCTS: "supplier/products",
    GET_ALL_PRODUCTS_REVIEWS: "supplier/products/reviews",
    SEARCH_PRODUCT_BY_SKU: "supplier/product/sku/:sku",
    RESTOCK_PRODUCT: "supplier/product/:id/restock",
    GET_INVENTORY_MOVEMENTS:
      "supplier/products/inventory/movements",
    EXPORT_INVENTORY_MOVEMENTS:
      "supplier/products/inventory/movements/export",
    UPDATE_VARIANT_STATUS: "supplier/product/:id/variant/:variantId/status",
    DELETE: "supplier/product/:id",
    EXPORT_PRODUCTS: "supplier/products/export",
    EXPORT_PRODUCT_REVIEWS: "supplier/products/reviews/export",
    LIST_ALL_PRODUCTS: "supplier/product/get-all",
  },
  ATTRIBUTE: {
    CREATE: "admin/attribute",
    UPDATE: "admin/attribute/:id",
    SINGLE: "admin/attribute/:id",
    GET_ALL_ATTRIBUTES: "admin/attributes",
    GET_ALL_ATTRIBUTES_WITH_VALUES: "admin/attributes/with-values",
    ADD_VALUE: "admin/attribute/:id/value",
    REMOVE_VALUE: "admin/attribute/:id/value/:valueId",
    DELETE: "admin/attribute/:id",
  },
  ATTRIBUTE_VALUE: {
    CREATE: "admin/attribute-value",
    GET_ALL_BY_ATTRIBUTE_ID: "admin/attribute-values/:attributeId",
    SINGLE: "admin/attribute-value/:id",
    UPDATE: "admin/attribute-value/:id",
    DELETE: "admin/attribute-value/:id",
  },
  DISCOUNT_RULES: {
    CREATE: "admin/discount-rule",
    UPDATE: "admin/discount-rule/:id",
    DELETE: "admin/discount-rule/:id",
    GET_ALL: "admin/discount-rules",
    GET_SINGLE: "admin/discount-rule/:id",
    GET_MATCHING_DISCOUNT_RULE: "discount-rule",
    ACTIVE_DISCOUNT_RULES: "discount-rules",
  },
  PLAN: {
    GET_ALL: "admin/plans",
    SINGLE: "admin/plan/:id",
    PLAN_DASHBOARD: "admin/plan/dashboard",
    DELETE: "admin/plan/:id",
    GET_CREDIT_SUGGESTION: "admin/user-plan/credit-suggestion",
  },
  PROMOTIONAL_BLOCK: {
    CREATE: "admin/promotional-block",
    GET_ALL: "admin/promotional-blocks",
    SINGLE: "admin/promotional-block/:id",
    UPDATE: "admin/promotional-block/:id",
    DELETE: "admin/promotional-block/:id",
  },
  BLOG_SUBSCRIBER: {
    GET_ALL: "admin/blog-subscriber",
  },
  CHARITY_ORGANIZATION: {
    CREATE: "admin/charity-organization",
    GET_ALL: "admin/charity-organizations",
    GET_LIST: "admin/charity-organizations/list",
    SINGLE: "admin/charity-organization/:id",
    UPDATE: "admin/charity-organization/:id",
  },
  DONATION: {
    GET_ALL: "admin/donations",
    EXPORT: "admin/donations/export",
    GET_SINGLE_BY_ORDER_ID: "admin/donations/:orderId/order",
  },
  BRAND: {
    CREATE: "admin/brand",
    UPDATE: "admin/brand/:id",
    GET: "admin/brands",
    SINGLE: "admin/brand/:id",
    SINGLE_BY_SLUG: "admin/brand/slug/:slug",
  },
  GIFT_CARD: {
    CREATE: "admin/gift-card",
    UPDATE: "admin/gift-card/:id",
    GET: "admin/gift-cards",
    SINGLE: "admin/gift-card/:id",
    SINGLE_BY_SLUG: "admin/gift-card/slug/:slug",
  },
  BLOG_TOPIC: {
    CREATE: "admin/blog-topic",
    UPDATE: "admin/blog-topic/:id",
    GET: "admin/blog-topics",
    LIST: "admin/blog-topic/list",
    SINGLE: "admin/blog-topic/:id",
    SINGLE_BY_SLUG: "admin/blog-topic/slug/:slug",
  },
  EVENT_CATEGORY: {
    CREATE: "admin/event-category",
    GET_ALL: "admin/event-categories",
    UPDATE: "admin/event-category/:id",
    DELETE: "admin/event-category/:id",
    GET_BY_ID: "admin/event-category/:id",
    GET_BY_SLUG: "admin/event-category/slug/:slug",
  },
  PROMO_CODE: {
    CREATE: "admin/promo-code",
    UPDATE: "admin/promo-code/:id",
    GET_ALL: "admin/promo-codes",
  },
};

export {
  emailRegex,
  passwordRegex,
  otpRegex,
  requestType,
  skuRegex,
  partialSkuRegex,
  endPoints,
  snackConst,
  CURRENCY,
  CSK_CONFIG,
  DEFAULT_VAT_PERCENTAGE,
  COLOR_OPTIONS,
  SIZES_OPTIONS,
  WEIGHT_OPTIONS,
  PREDEFINED_ATTRIBUTES,
  SIZE_TYPES,
  SIZE_BY_TYPE,
  PRODUCT_USAGE_TYPE,
  PACKAGE_USAGE_TYPE,
  BANNER_POSITION,
  urlRegex,
  ECOMMERCE_SOLUTION_TYPE,
  TAG_APPLIES_TO,
  ENDPOINTS,
  ALL_BLOG_CATEGORY,
  PLAN_DELIVERY_TYPES,
  INVENTORY_MOVEMENT_REASON,
  PROMOTIONAL_IMAGE_PAGE,
  PROMOTIONAL_IMAGE_SECTION,
  ORDER_STATUS_TRANSITIONS,
  USER_LIFE_STAGES,
};
